import React, { FC, useContext } from 'react';
import { SimpleOrderContext } from 'pages/order-flow/simple-order/simple-order-context';
import SimpleRestorations from 'components/order-flow/shared/constructions/simple-restorations.component';

type ConstructionProps = {
    disableEdit?: boolean;
};
const Constructions: FC<ConstructionProps> = ({ disableEdit }) => {
    const { order, setOrder } = useContext(SimpleOrderContext);
    return (
        <SimpleRestorations
            restorations={order.restorations}
            onChange={(restorations) => setOrder((prev) => ({ ...prev, restorations }))}
            disableEdit={disableEdit}
        />
    );
};

export default Constructions;
